module.exports = __webpack_public_path__ + "files/2f1780a60c701da8484340838c813cd7.png";